// extracted by mini-css-extract-plugin
export default {"terminal":"Terminal_terminal__97NCB","head":"Terminal_head__LDz-O","body":"Terminal_body__NqqDb","absolute":"Terminal_absolute__6BsXE","copied":"Terminal_copied__M0MBt"};